import { useCallback, useState } from 'react';

import type { EditorActions } from '@atlaskit/editor-core/actions';

import { getAllSmartLinks } from '../services/links.ts';

export const useInviteFromLinkExperimentEditor = (): {
	onEditorReady: (editorActions: EditorActions) => Promise<void>;
	startingLinks: Set<string> | undefined;
} => {
	const [startingLinks, setStartingLinks] = useState<Set<string>>();

	const onEditorReady = useCallback(async (editorActions: EditorActions): Promise<void> => {
		const adf = await editorActions.getValue();
		const links = getAllSmartLinks(adf);
		setStartingLinks(links);
	}, []);

	return {
		onEditorReady,
		startingLinks,
	};
};
